import { useEffect, useRef } from 'react';

const useAutoCancellingAnimationFrame = (): ((callback: FrameRequestCallback) => number) => {
    const cancelRef = useRef<number | null>(null);

    useEffect(() => {
        return () => {
            if (!cancelRef.current) return;

            cancelAnimationFrame(cancelRef.current);
            cancelRef.current = null;
        };
    }, []);

    return (callback: FrameRequestCallback) => {
        if (cancelRef.current) cancelAnimationFrame(cancelRef.current);
        cancelRef.current = requestAnimationFrame(callback);

        return cancelRef.current;
    };
};

export default useAutoCancellingAnimationFrame;
